export const InterfaceResourceStrategies = {
  Standard: 'standard',
  Deployed: 'deployed',
  Authorization: 'authorization',
  // platform auth pages (login/forgot/reset/update/mfa) — resolve ua-platform by id, pre-auth
  PlatformAuthorization: 'platformAuthorization',
  DeployedByVersion: 'DeployedByVersion',
  CachedResources: 'cachedResources',
  SavedByVersion: 'SavedByVersion',
} as const;

export type InterfaceResourceStrategyType =
  (typeof InterfaceResourceStrategies)[keyof typeof InterfaceResourceStrategies];

export type ResourceStrategyType = { strategy: InterfaceResourceStrategyType };
